import { SearchOutlined }                from '@ant-design/icons';
import { Form }                          from 'antd';
import { Input }                         from 'antd';
import { withNavigation }                from 'components/App/withNavigation';
import { WithNavigationProps }           from 'components/App/withNavigation';
import dayjs                             from 'dayjs';
import { Dayjs }                         from 'dayjs';
import AddStandMultiStepsForm            from 'forms/AddStandMultiStepsForm';
import { Observer }                      from 'mobx-react';
import StandModel                        from 'models/StandModel';
import { useEffect }                     from 'react';
import React                             from 'react';
import { message }                       from 'antd';
import { WrappedComponentProps }         from 'react-intl';
import { injectIntl }                    from 'react-intl';
import { Slider }                        from 'antd';
import { Button }                        from 'antd';
import { ClearOutlined }                 from '@ant-design/icons';
import { DatePicker }                    from 'antd';
import { ApiCollection }                 from 'collections/ApiCollection';
import { CsvCollection }                 from 'collections/CsvCollection';
import StandsSecurityAttestationZipModel from 'models/StandsSecurityAttestationZipModel';
import NotificationModel                 from 'models/NotificationModel';
import FormattedMessageWrapper           from 'components/App/FormattedMessageWrapper';
import DropDownMenu                      from 'components/App/DropDownMenu';
import { downloadFileFromBlob }          from 'utils/downloadFile';
import { messageErrorIntl }              from 'utils/messageIntl';
import SendNotificationForm              from 'forms/SendNotificationForm';
import Space                             from 'components/App/Space';
import rights                            from 'utils/rights';
import ShowModel                         from 'models/ShowModel';
import UserModel                         from 'models/UserModel';
import StandsCsvModel                    from 'models/StandsCsvModel';
import StandsMountingAttestationZipModel from 'models/StandsMountingAttestationZipModel';
import { AppForm }                       from 'components/App/AppForm';

const TopRightFilters = ({
  datesFilterName,
  onChange,
  standCollection,
}: {
  datesFilterName: string;
  onChange: (value: {
    dates?: [Dayjs, Dayjs];
    // layoutType?: number | number[];
    search?: string;
    surface?: [number, number];
  }) => void;
  standCollection: ApiCollection;
}) => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    onChange(values);
  };

  useEffect(() => {
    const standCollectionFilters: any = standCollection.filters;

    const dateAfter = standCollectionFilters[`${datesFilterName}[after]`]
      ? dayjs.utc(standCollectionFilters[`${datesFilterName}[after]`]).local()
      : undefined;

    const dateBefore = standCollectionFilters[`${datesFilterName}[before]`]
      ? dayjs.utc(standCollectionFilters[`${datesFilterName}[before]`]).local()
      : undefined;

    const lower = standCollectionFilters['surface[gte]'] || 0;
    const higher = standCollectionFilters['surface[lte]'] || 1000;

    form.setFieldsValue({
      dates: [dateAfter, dateBefore],
      // layoutType: standCollectionFilters.layoutType,
      search: standCollectionFilters.search,
      surface: [lower, higher],
    });
  }, []);

  useEffect(() => {
    const standCollectionFilters: any = standCollection.filters;

    const lower = standCollectionFilters['surface[gte]'] || 0;
    const higher = standCollectionFilters['surface[lte]'] || 1000;

    form.setFieldsValue({
      surface: [lower, higher],
      // other filters if needed
    });
  }, [standCollection.filters]);

  return <Observer>
    {() => (
      <Form
        form={form}
        initialValues={{ surface: [0, 1000] }}
        layout="inline"
        name="top_right_filters"
        onFinish={onFinish}
        style={{ marginRight: '-14px' }}
      >
        {/*<Form.Item*/}
        {/*  name="layoutType"*/}
        {/*>*/}
        {/*  <Select*/}
        {/*    allowClear*/}
        {/*    mode="multiple"*/}
        {/*    options={layoutTypeCollection.map((layoutType: LayoutTypeModel) => ({*/}
        {/*      label: layoutType.label,*/}
        {/*      value: layoutType.iri,*/}
        {/*    }))}*/}
        {/*    placeholder="Aménagements"*/}
        {/*    style={{ width: 200 }}*/}
        {/*  />*/}
        {/*</Form.Item>*/}

        <Form.Item
          name="dates"
        >
          <DatePicker.RangePicker
            allowClear
            format="DD/MM/YYYY"
            placeholder={[
              'Début',
              'Fin',
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Surface"
          name="surface"
        >
          <Slider
            // marks={{
            //   0: 0,
            //   1000: 1000,
            // }}
            max={1000}
            min={0}
            range
            style={{ width: 100 }}
          />
        </Form.Item>

        <Form.Item
          name="search"
        >
          <Input
            allowClear
            placeholder="Rechercher un stand"
            style={{ width: 200 }}
          />
        </Form.Item>

        <Form.Item shouldUpdate>
          {() => (
            <Button
              htmlType="submit"
              icon={<SearchOutlined />}
              type="primary"
            />
          )}
        </Form.Item>

        <Form.Item>
          <Button
            icon={<ClearOutlined />}
            onClick={() => {
              form.resetFields();
              form.submit();
            }}
          />
        </Form.Item>
      </Form>
    )}
  </Observer>;
};

export const DOCUMENT_MODE = 'document';

interface StandListTopRightWidgetProps extends WithNavigationProps, WrappedComponentProps {
  datesFilterName: string;
  fetchParentData: () => void;
  handleTopFiltersChange: (values: any) => void;
  mode?: string;
  selectedRows: any[];
  setDataLoading: (loading: boolean) => void;
  show: ShowModel;
  standCollection: ApiCollection<StandModel>;
  standCollectionFull: ApiCollection<StandModel>;
}

interface StandListTopRightWidgetState {
  exhibitor: UserModel;
  notification: NotificationModel;
  notificationTag?: string;
  selectedRows: any[];
}

class StandListTopRightWidget extends React.Component<StandListTopRightWidgetProps> {
  public state: StandListTopRightWidgetState = {
    exhibitor: new UserModel(),
    notification: new NotificationModel(),
    notificationTag: undefined,
    selectedRows: [],
  };

  public componentDidMount() {
    const { datesFilterName, standCollection } = this.props;

    const standCollectionFilters = standCollection.filters as any;

    const dateAfter = standCollectionFilters[`${datesFilterName}[after]`]
      ? dayjs.utc(standCollectionFilters[`${datesFilterName}[after]`]).local()
      : undefined;
    const dateBefore = standCollectionFilters[`${datesFilterName}[before]`]
      ? dayjs.utc(standCollectionFilters[`${datesFilterName}[before]`]).local()
      : undefined;

    const lower = standCollectionFilters['surface[gte]'] || 0;
    const higher = standCollectionFilters['surface[lte]'] || 1000;

    this.setState({
      dateAfter,
      dateBefore,
      search: standCollectionFilters.search,
      sliderValue: [lower, higher],
    });
  }

  public render() {
    const {
      datesFilterName,
      handleTopFiltersChange,
      standCollection,
    } = this.props;

    return (
      <Space
        additionalContainerStyle={{
          textAlign: 'right',
        }}
        direction="horizontal"
        justify="right"
        size={6}
      >
        <TopRightFilters
          datesFilterName={datesFilterName}
          onChange={values => {
            handleTopFiltersChange(values);
          }}
          standCollection={standCollection}
        />

        {this.renderTopRightMenu()}
      </Space>
    );
  }

  public renderTopRightMenu = () => {
    const {
      mode,
      selectedRows,
      show,
      standCollection,
      fetchParentData,
    } = this.props;

    const { showId } = this.props.params;

    const items = [];

    if (rights.for.stand.add && mode !== DOCUMENT_MODE) {
      items.push({
        icon: null,
        key: 'ADD_STAND',
        label: <FormattedMessageWrapper id="Ajouter un stand" />,
        onClick: () => AppForm.open(AddStandMultiStepsForm, {
          exhibitor: new UserModel(),
          onSuccess: ({
            exhibitor,
            openNotificationModal,
            stand,
            tag,
          }) => {
            standCollection.list();
            fetchParentData();

            if (openNotificationModal) {
              this.openSendNotificationModal(new NotificationModel({ users: [exhibitor.iri] }), tag, [stand]);
            }
          },
          showId,
        }, {
          title: <FormattedMessageWrapper id="Confirmer" />,
          width: 1024
        }),
        position: 1,
      });
    }

    if (rights.for.stand.export) {
      if (mode !== DOCUMENT_MODE) {
        items.push({
          icon: null,
          key: 'EXPORT_STANDS',
          label: <FormattedMessageWrapper id="Exporter" />,
          onClick: async () => {
            await this.exportStandsInCsv([
              'aisle',
              'bat',
              'firstAgency',
              'firstDecorator',
              'firstExhibitor',
              'hall',
              'id',
              'name',
              'nbClosedReports',
              'nbInProgressReports',
              'number',
              'show',
              'standType',
              'status',
              'surface',
            ]);
          },
          position: 2,
        });
      } else {
        items.push({
          icon: null,
          key: 'EXPORT_STANDS',
          label: <FormattedMessageWrapper id="Exporter" />,
          onClick: async () => {
            await this.exportStandsInCsv([
              'aisle',
              'bat',
              'documentsUpdatedAtFormatted',
              'hall',
              'id',
              'name',
              'number',
              'standDocumentStatus',
              'standType',
              'surface',
            ]);
          },
          position: 2,
        });
      }
    }

    if (rights.for.stand.import && mode !== DOCUMENT_MODE) {
      items.push({
        icon: null,
        key: 'IMPORT_STANDS',
        label: <FormattedMessageWrapper id="Importer" />,
        onClick: () => {
          this.props.navigate(`/salons/${showId}/stands/importation`);
        },
        position: 3,
      });
    }

    if (rights.for.notification.add) {
      items.push({
        icon: null,
        key: 'SEND_NOTIFICATION',
        label: <FormattedMessageWrapper id="Envoyer une notification" />,
        onClick: () => {
          this.openSendNotificationModal(new NotificationModel(), undefined, selectedRows);
        },
        position: 4,
      });
    }

    if (
      show?.securityInstructionsOption
      && rights.for.standsSecurityAttestation.zip
      && mode !== DOCUMENT_MODE
    ) {
      items.push({
        icon: null,
        key: 'DOWNLOAD_SECURITY_ATTESTATION',
        label: <FormattedMessageWrapper id="Télécharger les attestations de sécurité" />,
        onClick: () => {
          this.downloadStandsSecurityAttestationZip();
        },
        position: 5,
      });
    }

    if (
      show?.mountingAttestationOption
      && rights.for.mountingAttestation.zip
    ) {
      items.push({
        icon: null,
        key: 'DOWNLOAD_MOUNTING_ATTESTATION',
        label: <FormattedMessageWrapper id="Télécharger les attestations de bon montage" />,
        onClick: () => {
          this.downloadStandsMountingAttestationZip();
        },
        position: 6,
      });
    }

    if (!items.length) {
      return null;
    }

    return <DropDownMenu items={items} />;
  };

  private downloadStandsMountingAttestationZip = async () => {
    const {
      intl,
      selectedRows,
      setDataLoading,
      show,
      standCollectionFull,
    } = this.props;

    setDataLoading(true);

    const standsSecurityAttestationZip = new StandsMountingAttestationZipModel();

    let standsIds;

    if (selectedRows.length > 0) {
      standsIds = selectedRows.map(row => row.id);
    } else {
      standsIds = standCollectionFull.map(m => m.id);
    }

    try {
      const response = await standsSecurityAttestationZip.fetch({
        params: {
          ids: standsIds,
        },
      });

      const time = dayjs().format('YYYY-MM-DD_HHmm');
      const fileName = `${show.get('name')} - ${intl.formatMessage({
        id: 'attestations bon montage',
      })} - ${time}.zip`;
      const blob = new Blob([response.data], { type: 'application/zip' });
      downloadFileFromBlob(blob, fileName);
    } catch (error: any) {
      const reader = new FileReader();
      reader.addEventListener('loadend', (e: any) => {
        const text = e.srcElement.result;
        const json = JSON.parse(text);
        if (json['hydra:description']) {
          message.error(json['hydra:description']);
        } else {
          messageErrorIntl("Une erreur s'est produite.");
        }
      });
      reader.readAsText(error.connectorError.response.data);
    } finally {
      setDataLoading(false);
    }
  };

  private downloadStandsSecurityAttestationZip = async () => {
    const {
      intl,
      selectedRows,
      setDataLoading,
      show,
      standCollectionFull,
    } = this.props;

    setDataLoading(true);

    const standsSecurityAttestationZip = new StandsSecurityAttestationZipModel();

    let standsIds;

    if (selectedRows.length > 0) {
      standsIds = selectedRows.map(row => row.id);
    } else {
      standsIds = standCollectionFull.map(m => m.id);
    }

    try {
      const response: any = await standsSecurityAttestationZip.fetch({
        params: {
          ids: standsIds,
        },
      });

      const time = dayjs().format('YYYY-MM-DD_HHmm');
      const fileName = `${show.get('name')} - ${intl.formatMessage({
        id: 'fiches securite',
      })} - ${time}.zip`;
      const blob = new Blob([response.data], { type: 'application/zip' });
      downloadFileFromBlob(blob, fileName);
    } catch (error: any) {
      const reader = new FileReader();
      reader.addEventListener('loadend', (e: any) => {
        const text = e.srcElement.result;
        const json = JSON.parse(text);
        if (json['hydra:description']) {
          message.error(json['hydra:description']);
        } else {
          messageErrorIntl("Une erreur s'est produite.");
        }
      });
      reader.readAsText(error.connectorError.response.data);
    } finally {
      setDataLoading(false);
    }
  };

  private exportStandsInCsv = async (properties: string[]) => {
    const {
      selectedRows,
      setDataLoading,
    } = this.props;

    const { showId } = this.props.params;

    setDataLoading(true);

    const standsCsvCollection = new CsvCollection(StandsCsvModel);
    standsCsvCollection.setFilter('properties', properties);

    if (selectedRows.length > 0) {
      const standsIds = selectedRows.map(row => row.id);
      standsCsvCollection.setFilter('id', standsIds);
    } else {
      // we use show to avoid request too long with too many stands ids
      standsCsvCollection.setFilter('show', showId);
    }

    try {
      const response = await standsCsvCollection.list();

      const blob = new Blob([response.data], { type: 'text/csv' });
      const time = dayjs().format('YYYY-MM-DD_HHmm');
      const filename = `salon_${showId}_stands_${time}.csv`;
      downloadFileFromBlob(blob, filename);
    } catch {
      messageErrorIntl("Une erreur s'est produite.");
    }

    setDataLoading(false);
  };

  private openSendNotificationModal = (notification: NotificationModel, notificationTag: string | undefined, selectedRows: any[]) => {
    const { show, standCollectionFull } = this.props;

    const externalSync = show.get('externalSync', false);

    AppForm.open(SendNotificationForm, {
      externalSync: !!externalSync,
      model: notification,
      notificationTag,
      selectedRows,
      standCollectionFull,
    }, {
      okText: <FormattedMessageWrapper id="Envoyer" />,
      title: <FormattedMessageWrapper id="Envoyer une notification" />,
    });
  };
}

const StandListTopRightWidgetWrapped = injectIntl(withNavigation(StandListTopRightWidget));

export default StandListTopRightWidgetWrapped;
